export enum UserOPEEnum {
  PostLogin = 'postLogin',
  SetUserLanguage = 'setUserLanguage',
  DelUser = 'delUser',
  PutUser = 'putUser',
  GetUsers = 'getUsers',
  GetVisibleUsers = 'getVisibleUsers',
  UpdateUserPartition = 'updateUserPartition',
  GetUserMetricGroup = 'getUserMetricGroup',
  GetAllUserMetricGroup = 'getAllUserMetricGroup',
  PutUserMetricGroup = 'putUserMetricGroup',
  GetUserMetricGroups = 'getUserMetricGroups',
  GetAllUserMetricGroups = 'getAllUserMetricGroups',
  DelUserMetricGroup = 'delUserMetricGroup',
  ShareUserMetricGroup = 'shareUserMetricGroup',
  ValidateShareUserMetricGroupDraft = 'validateShareUserMetricGroupDraft',
  RefreshPushNotificationToken = 'refreshPushNotificationToken',
  SendUserWelcomeEmail = 'sendUserWelcomeEmail',
}
